import { AddressInput, CustomFieldElementType, ExtraField, ExtraFieldType } from '@web/graphql-components'

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

const valueKey = (field: ExtraField) =>
  field.customField?.id && field.type !== ExtraFieldType.Comments ? field.customField.id : field.name

const collectFields = (fields: ExtraField[]): ExtraField[] =>
  fields.flatMap((field) => [field, ...collectFields(field.conditionalFields ?? [])])

const fieldText = (field: ExtraField, values: Record<string, string>) =>
  (values[valueKey(field)] ?? values[field.name] ?? '').trim()

export const toPostDonationFormSubmission = (
  fields: ExtraField[],
  values: Record<string, string>,
  address?: AddressInput | null,
) => {
  const mobile = collectFields(fields)
    .filter((field) => field.type === ExtraFieldType.Phone)
    .map((field) => fieldText(field, values))
    .find((value) => value.length > 0)

  return {
    mobile,
    address: address ?? undefined,
    customFields: toPostDonationFormCustomFields(fields, values),
  }
}

export const toPostDonationFormCustomFields = (fields: ExtraField[], values: Record<string, string>) =>
  collectFields(fields).flatMap((field) => {
    if (field.type === ExtraFieldType.Phone || field.type === ExtraFieldType.Address) {
      return []
    }

    const raw = fieldText(field, values)
    if (!raw) {
      return []
    }

    const isMultiSelect =
      field.type === ExtraFieldType.Custom && field.customField?.elementType === CustomFieldElementType.MultiSelect
    const parsedValues = isMultiSelect
      ? raw
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean)
      : [raw]

    if (parsedValues.length === 0) {
      return []
    }

    const customFieldSettingId = field.customField?.id
    const name = (field.customField?.name || field.label || field.name).trim()
    if (!name) {
      return []
    }

    return [
      {
        ...(customFieldSettingId && UUID_PATTERN.test(customFieldSettingId) ? { customFieldSettingId } : {}),
        name,
        values: parsedValues,
      },
    ]
  })
